import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { createMuiTheme } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import MenuItem from '@material-ui/core/MenuItem';
import style from './style.module.scss';
import i18n from 'common/i18n';
import Message from 'components/Message';
import { useQueryClient } from 'react-query';
import cloneDeep from 'lodash/cloneDeep';
import uniq from 'lodash/uniq';
import { getAllAreaJobByState } from '../../../api/itemJobResources';
import { SEARCH_TYPE } from '../../../config/constants';

const customTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiDialog: {
      paperWidthSm: {
        width: '488px',
        maxHeight: '80%',
      },
      paper: {
        borderRadius: '20px 20px 20px 20px',
      },
    },
    MuiDialogActions: {
      root: {
        display: 'flex',
        justifyContent: 'center',
      },
    },
    MuiDialogContent: {
      root: {
        padding: 0,
      },
    },
  },
});

const stylePaddingListItem = {
  padding: '5px 0',
};

function FormDialog(props) {
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [value, setValue] = useState(null);
  const [values, setValues] = useState([]);
  const [valueContents, setValueContents] = useState({});
  const [nameArea, setNameArea] = useState([]);

  useEffect(() => {
    const fetch = async (userState) => {
      const { data: nameArea } = await getAllAreaJobByState(userState);
      setNameArea(nameArea);
      let areaText = nameArea.find(ele => ele.id === props.values)?.label;
      // Fixed
      // eslint-disable-next-line no-unused-expressions
      props?.setTextValueObj({...props?.valueTextObj && props?.valueTextObj, area: areaText})
    };

    if (props.userState) {
      fetch(props.userState);
    }
    // Trigger userState
  }, [props.userState]);

  const onChangePopupItems = (value, content) => {
    const tmpValues = cloneDeep(values);
    const index = values.indexOf(value);

    if (!!props?.multi) {
      if (index !== -1) {
        // Remove
        tmpValues.splice(index, 1);
      } else {
        tmpValues.push(value);
      }
      setValues(uniq(tmpValues));
      setValueContents({ ...valueContents, [value]: content });
    } else {
      // No multi
      setValues([value]);
      setValueContents({ [value]: content });

    }
    // setValue(value);
    if (!props?.multi) {
      // Data single
      updateChangeValue((index === -1 ? value : null), (index === -1 ? content : ''));
    }
  };

  const updateChangeValue = async (value, contents) => {
    if (!!props?.multi) {
      // Fixed
      // eslint-disable-next-line no-unused-expressions
      props?.onchangeData(values, props.nametext, valueContents);
      setOpen(false);
      return;
    }

    props.onchangeData(value, props.nametext, contents);
    setOpen(false);
  };

  useEffect(() => {
    if (props?.values && Array.isArray(props.values)) {
      setValues(props.values);

      if (props.values.length) {
        setValue(props.values[0]);
      }
    } else {
      setValues([props.values]);
      setValue(props.values);
    }

    if (open) {
      setTimeout(() => {
        handleClose();
      }, 3000);
    }
  }, [open]);

  const handleClose = () => {
    setOpenAlert(false);
    setAlertMessage('');
  };

  const onHandleClose = () => {
    setValue(null);
    setValues([]);
    setOpen(false);
  };

  return (
    <div>
      <div
        onClick={() => setOpen(true)}
        style={{
          minHeight: 30,
          border: '1px solid',
          borderRadius: 10,
          ...props?.customStyleContainer,
          ...props?.text && {
            padding: '0 10px',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            cursor: 'text',
          },
        }}
        className="border-color wrap-item-filter"
      >
        {props?.text && (<span className="font-3 d-text-search-color"
                               dangerouslySetInnerHTML={{ __html: props?.text }}></span>)}
      </div>
      <MuiThemeProvider theme={customTheme}>
        <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="form-dialog-title">
          <div className={`${style.name__lable} box-header`}>
            <div>{props.namelabel}</div>
          </div>
          <div className={style.__clearicon}>
            <ClearIcon style={{ cursor: 'pointer' }} onClick={() => onHandleClose()} color="action" />
          </div>
          <DialogContent>
            {[SEARCH_TYPE.DROPDOWN, SEARCH_TYPE.CHECKBOX, SEARCH_TYPE.RANGE].includes(props.typeSearch) && (
              <div id={props?.nametext}>
                {props.resource?.sort((a, b) => a?.value - b?.value)
                  ?.map((value, key) => {
                  return (
                    <MenuItem
                      key={key}
                      id={value.value}
                      className={
                        (values ?? []).includes(value?.value)
                          ? `${style.__select_profile} box-selected-item box-text`
                          : `${style.__no__select_profile} box-select-item`
                      }
                      value={value.value}
                      style={{ ...stylePaddingListItem }}
                      onClick={() => onChangePopupItems(value.value, value?.label)}
                    >
                      <span
                        className={`${(values ?? []).includes(value?.value) ? '' : 'box-text'}`}>{value.label}</span>
                    </MenuItem>
                  );
                })}
              </div>
            )}

            {(props?.nametext === 'jobTags' || props?.nametext === 'state') && (
              <div id={props?.nametext}>
                {props.resource?.map((item, key) => {
                  return (
                    <MenuItem
                      key={key}
                      id={item?.id}
                      className={
                        !!(values ?? []).includes(item?.id)
                          ? `${style.__select_profile} box-selected-item box-text`
                          : `${style.__no__select_profile} box-select-item`
                      }
                      value={item?.id}
                      style={{ ...stylePaddingListItem }}
                      onClick={() => onChangePopupItems(item?.id, item?.label)}
                    >
                      <span className={`${(values ?? []).includes(item?.id) ? '' : 'box-text'}`}>{item?.label}</span>
                    </MenuItem>
                  );
                })}
              </div>
            )}

            {(props?.nametext === 'area') && (
              <div id={props?.nametext}>
                {nameArea?.map((item, key) => {
                  if (!item?.label) {
                    return
                  }
                  return (
                    <MenuItem
                      key={key}
                      id={item?.id}
                      className={
                        !!(values ?? []).includes(item?.id)
                          ? `${style.__select_profile} box-selected-item box-text`
                          : `${style.__no__select_profile} box-select-item`
                      }
                      value={item?.id}
                      style={{ ...stylePaddingListItem }}
                      onClick={() => onChangePopupItems(item?.id, item?.label)}
                    >
                      <span className={`${(values ?? []).includes(item?.id) ? '' : 'box-text'}`}>{item?.label}</span>
                    </MenuItem>
                  );
                })}
              </div>
            )}

          </DialogContent>
          <DialogActions>
            {props?.multi && !!props.multi && (
              <Button className={`${style.button__save__profile} btn-sub`}
                      onClick={() => updateChangeValue()} color="primary">
                {i18n.button_save}
              </Button>)}
          </DialogActions>
          <div></div>
        </Dialog>
      </MuiThemeProvider>
      {open ? <Message open={openAlert} handleClose={handleClose} alertMessage={alertMessage} /> : null}
    </div>
  );
}

export default FormDialog;
